import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { FaqsService } from './faqs.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class FaqsServiceModule {
  static forRoot(): ModuleWithProviders<FaqsServiceModule> {
    return {
      ngModule: FaqsServiceModule,
      providers: [FaqsService],
    };
  }
}
